var fontWeights = {
  thin: 100,
  extralight: 200,
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extrabold: 800,
  black: 900
};

/**
 * Parses font-weight name to the numeric value
 *
 * @param weight - Name of font-weight
 * @returns The numeric value of font-weight
 */
var getFontWeight = function getFontWeight(weight) {
  return fontWeights[weight];
};
export default getFontWeight;